export default __webpack_public_path__ + "static/media/AI_Brain_Icon.381bb3c1.gif";